<template>
    <InfoPageLayout title="About Us" :content="aboutUs?.content" />
</template>

<script setup>
import InfoPageLayout from '@/components/layouts/InfoPageLayout.vue';
import { ref } from 'vue';
import { getAboutUs } from '@/services/pageService';

const aboutUs = ref(null);

getAboutUs().then(response => {
    aboutUs.value = response.data;
});
</script>
